import React, { Component } from "react";
import MyEventNav from "./MyEventNav";
import { http, baseURL } from "../../misc/http";
import defaultImage from "../../assets/default.jpg";
import moment from "moment";
import { Link } from "react-router-dom";
import { getStatus } from "../../misc/misc";
import classes from "./styles.module.scss";
import classNames from "classnames";

export default class MyEvent extends Component {
  state = {
    activePage: "myEvent",
    userEventList: [],
  };

  componentDidMount = async () => {
    this.getUserEventList();
  };

  getUserEventList = async () => {
    let params = {
      method: "GET",
      path: "events/join/getListByUser",
      showMessage: false,
    };
    let userEventList = await http(params);
    console.log(userEventList.data.data);
    if (userEventList.status === 200) {
      if (userEventList.data.message !== "Data event tidak ditemukan!")
        this.setState({ userEventList: userEventList.data.data });
      else this.setState({ userEventList: [] });
    }
  };

  handleOnclick = (activePage) => {
    this.setState({ activePage: activePage });
  };

  renderUserEventList = () => {
    let userEventList = [];
    for (const e of this.state.userEventList) {
      if (
        this.state.activePage === "history" &&
        getStatus(e.eventData.startDate) === "SUDAH SELESAI"
      )
        userEventList.push(e);
      else if (
        this.state.activePage === "myEvent" &&
        getStatus(e.eventData.startDate) !== "SUDAH SELESAI"
      )
        userEventList.push(e);
    }
    return (
      <div className="container">
        <div className="row" style={{ flexWrap: "wrap", overflowX: "auto" }}>
          {userEventList.length > 0 ? (
            userEventList.map((e) => (
              <div
                className={classNames(
                  "col-lg-4 col-md-4 col-sm-10 col-10",
                  classes.eventCard
                )}
              >
                <div
                  className={classNames(classes.typeEvent, {
                    [classes.webinar]: e.eventData.eventType === "webinar",
                  })}
                >
                  <p>
                    {e.eventData.eventType === "webinar"
                      ? "Live Webinar"
                      : e.eventData.eventType}
                  </p>
                </div>
                <img
                  className="mb-4"
                  src={
                    e.eventData.picture
                      ? baseURL + "/" + e.eventData.picture
                      : defaultImage
                  }
                  alt="grey"
                  style={{ width: "100%", height: "150px", objectFit: "cover" }}
                />
                <div className="d-flex">
                  <div className="text-center">
                    <p
                      style={{
                        fontSize: "18px",
                        color: "#15A325",
                        fontWeight: "600",
                      }}
                    >
                      {moment(e.eventData.startDate).format("MMMM")}
                    </p>
                    <p style={{ fontSize: "18px", fontWeight: "600" }}>
                      {moment(e.eventData.startDate).format("DD")}
                    </p>
                  </div>
                  <div className="ml-5">
                    <Link
                      to={`/event_detil/${e.eventData._id}`}
                      style={{ color: "black" }}
                    >
                      <p style={{ fontSize: "18px", fontWeight: "600" }}>
                        {e.eventData.title}
                      </p>
                    </Link>
                    <p className="text-muted">
                      {moment(e.eventData.startDate).format("ddd, MMMM DD")},{" "}
                      {e.eventData.startTime}
                    </p>
                    <p className="text-muted">{e.eventData.location}</p>
                    {/* <p style={{ fontSize: "16px", fontWeight: "600" }}>
                      {getStatus(e.eventData.startDate)}
                    </p> */}
                    <p style={{ fontSize: "16px", fontWeight: "600" }}>
                      GRATIS
                    </p>
                  </div>
                </div>
                <p className={classes.statusEvent}>Terdaftar</p>
                <button
                  class="btn btn-blue w-100 mb-3"
                  style={{
                    padding: "11px 25px !important",
                    fontSize: "13px",
                  }}
                >
                  {e.eventData.eventType === "event"
                    ? "DOWNLOAD E-TIKET"
                    : "BUKA LINK"}
                </button>
              </div>
            ))
          ) : (
            <div>No data founded</div>
          )}
        </div>
      </div>
    );
  };

  render() {
    return (
      <section className="kegiatan-acara-saya">
        <div style={{ borderBottom: "1px solid rgba(0,0,0,0.12)" }}>
          <MyEventNav
            activePage={this.state.activePage}
            handleOnclick={this.handleOnclick}
          />
        </div>
        <div className="tab-content" id="pills-tabKegiatanAcara">
          <div
            className="tab-pane fade show active"
            id="pills-acara"
            role="tabpanel"
            aria-labelledby="pills-acara-tab"
          >
            {this.renderUserEventList()}
          </div>
        </div>
      </section>
    );
  }
}
